import {
  computed,
  DestroyRef,
  Directive,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

import {LoadingService} from '@shared/services/loading.service';

@Directive({
  selector: 'button[smsir-button][httpLoading]',
  standalone: true,
  host: {
    '[loading]': 'loading()',
  },
})
export class SmsirButtonHttpLoadingDirective {
  private readonly loadingService = inject(LoadingService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly clicked = signal(false);
  private readonly httpLoading = signal(false);

  protected readonly loading = computed(() => this.clicked() && this.httpLoading());

  constructor() {
    this.loadingService.buttonLoading$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((loading) => {
        this.httpLoading.set(loading);
        if (!loading) {
          this.clicked.set(false);
        }
      });
  }

  @HostListener('click')
  onClick(): void {
    this.clicked.set(true);
  }
}
